import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className="skf-header">
      <Link to="/" aria-label="Skiffs home">
        <img className="skf-logo" src="/logo-white.png" alt="Skiffs Logo" />
      </Link>
    </header>
  );
}
